import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import logo from '../assets/logo.png';

const API_BASE_URL = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:5000');

const SignupPage = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1); // 1: 사업자번호 확인, 2: 회원정보 입력
  const [businessNumber, setBusinessNumber] = useState('');
  const [verificationError, setVerificationError] = useState('');
  const [isBusinessVerified, setIsBusinessVerified] = useState(false);
  const [focusedField, setFocusedField] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    confirmPassword: '',
    phone: ''
  });

  // 약관 동의 상태
  const [agreeAll, setAgreeAll] = useState(false);
  const [agreeTerms, setAgreeTerms] = useState(false);
  const [agreePrivacy, setAgreePrivacy] = useState(false);

  const [signupError, setSignupError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [termsError, setTermsError] = useState('');

  // 각 필드별 에러 상태
  const [fieldErrors, setFieldErrors] = useState({
    username: '',
    password: '',
    confirmPassword: '',
    email: '',
    phone: ''
  });

  // 약관 모달 상태
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);

  // 약관 내용
  const termsOfServiceContent = `와우오더 서비스 이용약관

제1조 (목적)
본 약관은 와우오더(이하 "회사")가 제공하는 와우오더 서비스(이하 "서비스")의 이용조건 및 절차에 관한 사항, 회사와 이용자의 권리와 의무 및 책임사항을 규정함을 목적으로 합니다.

제2조 (정의)
본 약관에서 사용하는 용어의 정의는 다음과 같습니다.
1. "서비스"란 회사가 제공하는 QR 코드 기반 비대면 주문 서비스(와우오더 QR 주문 웹 서비스, 와우오더 사장님 앱, 회사 홈페이지 등 관련 제반 서비스)를 의미합니다.
2. "이용자"란 본 약관에 따라 회사가 제공하는 서비스를 이용하는 자를 의미하며, 매장 사업자(이하 "가맹점")와 매장 내 주문 고객(이하 "주문 고객")을 포함합니다.
3. "가맹점"이란 회사와 서비스 이용계약을 체결하고, 매장 내 QR 코드를 통해 주문 서비스를 제공받는 사업자를 의미합니다.
4. "주문 고객"이란 가맹점 매장 내에서 QR 코드를 스캔하여 메뉴 조회 및 주문을 하는 자를 의미합니다.
5. "와우오더 사장님 앱"이란 가맹점이 매장 관리, 메뉴 관리, 주문 내역 조회, 정산 등을 할 수 있도록 회사가 제공하는 모바일 애플리케이션을 의미합니다.
6. "POS 시스템"이란 가맹점이 사용하는 판매시점관리시스템으로, 서비스를 통해 접수된 주문이 연동되는 시스템을 의미합니다.
7. "게시물"이란 이용자가 서비스를 이용함에 있어 서비스상에 게시한 부호·문자·음성·음향·화상·동영상 등의 정보 형태의 글, 사진, 동영상 및 각종 파일과 링크 등을 의미합니다.

본 약관에서 사용하는 용어의 정의는 제1항에서 정하는 것을 제외하고는 관계 법령에서 정하는 바에 의합니다.

제3조 (약관의 효력 및 변경)
1. 이 약관은 회사 홈페이지(woworder.kr) 및 와우오더 사장님 앱에 게시함으로써 그 효력이 발생됩니다.
2. 회사는 합리적인 사유가 발생할 경우 이 약관의 내용을 변경할 수 있으며, 변경된 약관은 제11조와 같은 방법으로 공시함으로써 그 효력이 발생됩니다.
3. 이용자가 변경된 약관에 동의하지 않는 경우 서비스 이용을 중단하고 이용계약을 해지할 수 있습니다. 변경된 약관의 효력 발생일 이후에도 서비스를 계속 이용하는 경우에는 변경된 약관에 동의한 것으로 봅니다.

제4조 (약관 외 준칙)
이 약관에 명시되어 있지 않은 사항은 「전기통신기본법」, 「전기통신사업법」, 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」, 「전자상거래 등에서의 소비자보호에 관한 법률」 및 기타 관련 법령의 규정에 따릅니다.
회사는 서비스 중 특정 서비스에 관한 약관(이하 "개별 약관")을 별도로 제정할 수 있으며, 이용자가 개별 약관에 동의 시 개별 약관은 이용계약의 일부를 구성하고, 개별 약관에 본 약관과 상충하는 내용이 있을 경우 개별 약관이 우선적으로 적용됩니다.

제5조 (이용계약의 체결)
1. 가맹점의 이용계약은 서비스 이용을 희망하는 사업자가 회사가 정한 가입 절차에 따라 이용신청을 하고, 회사가 이를 승낙함으로써 체결됩니다.
2. 주문 고객은 매장 내 QR 코드를 스캔하여 서비스에 접속하는 것으로 본 약관에 동의한 것으로 봅니다. 주문 고객은 별도의 회원가입 없이 서비스를 이용할 수 있습니다.
3. 회사는 다음 각 호에 해당하는 이용신청에 대하여 승낙을 하지 않거나 사후에 이용계약을 해지할 수 있습니다.
가. 실명이 아니거나 타인의 명의를 이용하여 신청한 경우
나. 이용신청 시 필요한 사항을 허위로 기재한 경우
다. 사회의 안녕질서 또는 미풍양속을 저해할 목적으로 신청한 경우
라. 기타 회사가 정한 이용신청 요건에 충족되지 않은 경우

제6조 (서비스의 제공 및 변경)
회사가 제공하는 서비스는 다음과 같습니다.
1. QR 코드 기반 비대면 주문 서비스 (주문 고객용 QR 주문 웹 서비스)
2. 와우오더 사장님 앱 (매장 관리, 메뉴 관리, 주문 내역 조회, 정산 등)
3. POS 시스템 연동 서비스
4. 회사 홈페이지를 통한 서비스 안내 및 상담 신청
5. 기타 회사가 정하는 서비스

회사는 서비스의 내용, 이용방법, 이용시간 등을 변경할 수 있으며, 변경 사항은 제11조에 정한 방법으로 이용자에게 통지합니다.

제7조 (서비스의 중단)
1. 회사는 컴퓨터 등 정보통신설비의 보수점검·교체 및 고장, 통신의 두절, 천재지변 또는 이에 준하는 불가항력적 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다.
2. 제1항에 의한 서비스 중단의 경우에는 제11조에 정한 방법으로 이용자에게 통지합니다. 다만, 회사가 사전에 통지할 수 없는 부득이한 사유가 있는 경우 사후에 통지할 수 있습니다.
3. 회사는 서비스의 제공에 필요한 경우 정기점검을 실시할 수 있으며, 정기점검시간은 서비스 제공 화면 또는 공지사항에 공지한 바에 따릅니다.

제8조 (회사의 의무)
1. 회사는 이 약관에서 정한 바에 따라 계속적이고 안정적으로 서비스를 제공할 수 있도록 최선의 노력을 다합니다.
2. 회사는 서비스에 관련된 설비를 항상 운용할 수 있는 상태로 유지·보수하고, 장애가 발생하는 경우 지체 없이 이를 수리·복구할 수 있도록 최선의 노력을 다합니다.
3. 회사는 「개인정보 보호법」 등 관계 법령이 정하는 바에 따라 이용자의 개인정보를 보호하기 위해 노력합니다. 개인정보의 보호 및 사용에 대해서는 관련 법령 및 회사의 개인정보 처리방침이 적용됩니다.
4. 회사는 이용자로부터 제기되는 의견이나 불만이 정당하다고 인정할 경우에는 신속히 처리합니다. 다만, 신속한 처리가 곤란한 경우에는 이용자에게 그 사유와 처리일정을 통보합니다.

제9조 (이용자의 의무)
1. 이용자는 관계법령, 이 약관의 규정, 이용안내 및 주의사항 등 회사가 통지하는 사항을 준수하여야 하며, 기타 회사의 업무에 방해되는 행위를 하여서는 아니됩니다.
2. 이용자는 서비스를 이용하여 얻은 정보를 회사의 사전 승낙없이 복사, 복제, 변경, 번역, 출판/방송 기타의 방법으로 사용하거나 이를 타인에게 제공할 수 없습니다.
3. 이용자는 서비스 이용과 관련하여 다음 각 호의 행위를 하지 않아야 하며, 다음 행위를 함으로 발생하는 모든 결과에 대한 책임은 이용자에게 있습니다.
가. 범죄행위를 목적으로 하거나 기타 범죄행위와 관련된 행위
나. 선량한 풍속, 기타 사회질서를 해하는 행위
다. 타인의 명예를 훼손하거나 모욕하는 행위
라. 타인의 지적재산권 등의 권리를 침해하는 행위
마. 해킹행위 또는 컴퓨터 바이러스의 유포행위
바. 타인의 의사에 반하여 광고성 정보 등 일정한 내용을 지속적으로 전송하는 행위
사. 서비스의 안정적인 운영에 지장을 주거나 줄 우려가 있는 일체의 행위
아. 회사가 제공하는 서비스의 내용을 변경하는 행위
자. 문의하기, 상담 신청 등 서비스를 통해 회사에 욕설, 음란성 글을 인입시키는 행위
차. 회사의 서비스를 이용하여 부당한 이득을 취하는 행위
카. 서비스를 통해 접수된 주문을 고의로 누락·지연·거부하여 주문 고객에게 피해를 주는 행위
타. 기타 관계법령에 위배되는 행위
4. 가맹점은 서비스를 통해 등록하는 메뉴 정보(메뉴명, 가격, 성분, 알레르기 정보, 원산지 정보 등)의 정확성 및 관련 법령 준수에 대해 전적으로 책임을 지며, 부정확한 정보로 인해 발생하는 분쟁 및 법적 책임에 대하여 회사는 일체의 책임을 부담하지 않습니다.
5. 가맹점은 서비스 이용에 필요한 장비(POS 시스템, 네트워크 환경 등)를 자기 비용으로 유지·관리하여야 하며, 장비 장애로 인한 서비스 이용 불가에 대해 회사는 책임을 부담하지 않습니다.
6. 가맹점은 회사가 제공하는 QR 코드 및 관련 자료를 서비스 본래 목적 외의 용도로 사용할 수 없습니다.

제10조 (서비스 이용료 및 정산)
1. 서비스 이용료는 회사와 가맹점 간의 개별 계약에서 정한 바에 따릅니다.
2. 회사는 서비스 이용료를 CMS 자동이체, 세금계산서 발행 등 회사가 정한 방법으로 청구·정산합니다.
3. 가맹점이 이용료를 기한 내에 납부하지 않은 경우, 회사는 서비스 제공을 중단하거나 이용계약을 해지할 수 있습니다.

제11조 (이용자에 대한 통지)
1. 회사가 이용자에 대한 통지를 하는 경우 이 약관에 별도 규정이 없는 한 이용자가 제공한 이메일, 전화번호, 카카오 알림톡 등으로 할 수 있습니다.
2. 회사가 불특정 다수의 이용자에게 통지를 해야 할 경우 1주일 이상 홈페이지 또는 와우오더 사장님 앱의 공지사항에 게시함으로써 개별 통지에 갈음할 수 있습니다.

제12조 (계약 해지 및 이용 제한)
1. 가맹점이 이용계약을 해지하고자 하는 경우에는 회사가 정한 절차에 따라 해지 신청을 하여야 합니다.
2. 회사는 이용자가 다음 각 호에 해당하는 행위를 하였을 경우, 사전 통지 없이 서비스 이용을 제한하거나 이용계약을 해지할 수 있습니다.
가. 본 약관을 위반한 경우
나. 서비스 운영을 고의로 방해한 경우
다. 타인의 명의를 도용한 경우
라. 회사의 서비스를 이용하여 법령 또는 공공질서·미풍양속에 반하는 행위를 한 경우
마. 서비스 이용료를 3개월 이상 연체한 경우
3. 이용계약이 해지되는 경우, 해지 이전에 이미 발생한 이용료 등 채무는 해지에 의하여 영향을 받지 않으며, 가맹점은 미납 이용료를 지체 없이 납부하여야 합니다.
4. 이용계약이 해지되는 경우 회사는 관련 법령 및 개인정보 처리방침에 따라 보유하는 이용자 정보를 제외하고는 이용자의 개인정보를 지체 없이 파기합니다.

제13조 (지식재산권)
1. 서비스에 관한 저작권 및 지식재산권은 회사에 귀속됩니다.
2. 이용자는 서비스를 이용함으로써 얻은 정보 중 회사에 지식재산권이 귀속되는 정보를 회사의 사전 승낙 없이 복제, 송신, 출판, 배포, 방송 기타 방법에 의하여 영리 목적으로 이용하거나 제3자에게 이용하게 하여서는 안 됩니다.
3. 가맹점이 서비스에 등록한 메뉴 정보, 이미지 등의 저작권은 해당 가맹점에 귀속됩니다. 다만, 회사는 서비스 제공 및 서비스 홍보·마케팅 목적 범위 내에서 해당 정보를 무상으로 이용할 수 있습니다.

제14조 (광고 게재)
1. 회사는 서비스의 운영과 관련하여 앱, 홈페이지, QR 주문 페이지 등에 광고를 게재할 수 있습니다.
2. 이용자가 서비스상에 게재된 광고를 이용하거나 광고주의 판촉활동에 참여하는 등의 방법으로 교신 또는 거래를 하는 것은 전적으로 이용자와 광고주 간의 문제이며, 이와 관련하여 발생하는 손해에 대해 회사는 책임을 부담하지 않습니다.

제15조 (손해배상)
1. 회사는 무료로 제공되는 서비스와 관련하여 이용자에게 어떠한 손해가 발생하더라도 동 손해가 회사의 중대한 과실에 의한 경우를 제외하고 이에 대하여 책임을 부담하지 아니합니다.
2. 회사가 유료로 제공하는 서비스의 경우에도 회사의 손해배상 범위는 이용자가 회사에 지급한 서비스 이용료의 총액을 한도로 합니다. 다만, 회사의 고의 또는 중대한 과실에 의한 경우에는 그러하지 아니합니다.
3. 회사는 이용자의 서비스 이용과 관련하여 기대하는 이익에 관하여 책임을 부담하지 않습니다.
4. 이용자가 본 약관의 규정을 위반함으로 인하여 회사가 이용자 또는 제3자에 대하여 책임을 부담하게 되고, 이로써 회사에 손해가 발생하게 되는 경우, 해당 이용자는 회사에 발생하는 모든 손해를 배상하여야 하며, 동 손해로부터 회사를 면책시켜야 합니다.

제16조 (면책 조항)
1. 회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다.
2. 회사는 이용자의 귀책사유로 인한 서비스 이용의 장애에 대하여 책임을 부담하지 않습니다.
3. 회사는 가맹점이 서비스를 통해 제공하는 메뉴의 품질, 가격, 안전성, 원산지 표시 등에 대하여 보증하지 않으며, 이로 인한 분쟁에 대해 책임을 부담하지 않습니다. 가맹점과 주문 고객 간의 거래에 관한 분쟁은 당사자 간에 해결하여야 합니다.
4. 회사는 POS 시스템, 결제 시스템, 통신망 등 제3자가 제공하는 시스템 및 서비스의 장애로 인해 발생하는 손해에 대해 책임을 부담하지 않습니다.
5. 회사는 이용자가 서비스를 이용하여 기대하는 수익을 얻지 못하거나 상실한 것에 대하여 책임을 부담하지 않습니다.
6. 회사는 이용자 상호간 또는 이용자와 제3자 간에 서비스를 매개로 발생한 분쟁에 대하여 개입할 의무가 없으며, 이로 인한 손해를 배상할 책임을 부담하지 않습니다.
7. 회사는 이용자가 자신의 개인정보(아이디, 비밀번호 등)를 타인에게 유출 또는 제공함으로써, 이용자의 기기 관리 소홀로 인하여, 또는 회사가 관리하지 않는 영역에서의 사고로 인하여 발생하는 손해에 대해 책임을 부담하지 않습니다.

제17조 (분쟁 해결)
1. 회사와 이용자 간에 발생한 서비스 이용에 관한 분쟁에 대하여는 대한민국 법을 적용합니다.
2. 서비스 이용으로 발생한 분쟁에 대하여 소송이 제기될 경우 회사의 본사 소재지를 관할하는 법원을 전속적 관할법원으로 합니다.

제18조 (기타)
1. 회사는 필요한 경우 특정 서비스에 관하여 적용될 사항(이하 "개별약관")을 정하여 미리 공지할 수 있습니다.
2. 본 약관의 어느 조항이 관련 법령에 의하여 무효 또는 집행불능으로 판정되는 경우에도 나머지 조항의 유효성에는 영향을 미치지 않습니다.
3. 이용자가 본 약관에 동의하는 것은 서비스와 관련하여 회사가 발송하는 서비스 관련 통지, 관리 메시지 등을 수신하는 것에 동의하는 것을 포함합니다.

이 약관은 2026. 03. 06 부터 시행됩니다.`;

  const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '12px',
    marginBottom: '16px',
    fontSize: '12px',
    lineHeight: '1.6'
  };
  const thStyle = {
    backgroundColor: '#F5F5F5',
    border: '1px solid #ddd',
    padding: '8px',
    fontWeight: '600',
    textAlign: 'center',
    verticalAlign: 'middle'
  };
  const tdStyle = {
    border: '1px solid #ddd',
    padding: '8px',
    verticalAlign: 'middle'
  };
  const sectionTitleStyle = {
    fontWeight: 'bold',
    fontSize: '14px',
    marginTop: '24px',
    marginBottom: '0',
    paddingBottom: '8px',
    borderBottom: '1px solid #ddd'
  };
  const pStyle = {
    fontSize: '13px',
    lineHeight: '1.8',
    color: '#333',
    margin: '8px 0'
  };

  const privacyPolicyContent = (
    <div>
      <p style={pStyle}><strong>와우오더</strong>는 정보주체의 자유와 권리 보호를 위해 「개인정보 보호법」 및 관계 법령이 정한 바를 준수하여, 적법하게 개인정보를 처리하고 안전하게 관리하고 있습니다.</p>
      <p style={pStyle}>이에 「개인정보 보호법」 제30조에 따라 정보주체에게 개인정보 처리에 관한 절차 및 기준을 안내하고, 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다.</p>

      <p style={sectionTitleStyle}>1. 처리하는 개인정보 항목, 수집 및 이용 목적, 보유 및 이용 기간</p>
      <p style={pStyle}>와우오더는 서비스 제공을 위해 필요 최소한의 범위에서 개인정보를 수집·이용합니다.</p>
      <p style={{...pStyle, fontWeight: '600'}}>① 정보주체의 동의를 받지 않고 처리하는 개인정보 항목</p>
      <p style={pStyle}>와우오더는 다음의 개인정보 항목을 정보주체의 동의 없이 처리하고 있습니다.</p>
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={thStyle}>법적근거</th>
            <th style={thStyle}>구분</th>
            <th style={thStyle}>수집 목적</th>
            <th style={thStyle}>수집 항목</th>
            <th style={thStyle}>보유 및 이용기간</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td rowSpan={3} style={{...tdStyle, textAlign: 'center'}}>개인정보 보호법 제15조 제1항 제4호 (계약 체결·이행)</td>
            <td style={tdStyle}>매장</td>
            <td style={tdStyle}>계약서 작성, 세금계산서 발행, 출고 신청, CMS 자동이체</td>
            <td style={tdStyle}>생년월일, 이름, 업종, 성별, 사업자등록번호, 소재지, 영업종류, 주소, 사업자 통장(은행명, 계좌번호, 예금주), 휴대전화번호, 이메일주소, 임대차 정보(임차인명, 소재지, 계약기간), (법인의 경우) 법인인감증명서 정보</td>
            <td style={tdStyle}>계약 종료일로부터 5년</td>
          </tr>
          <tr>
            <td style={tdStyle}>정산 정보</td>
            <td style={tdStyle}>서비스 이용료 정산, 세금계산서 발행</td>
            <td style={tdStyle}>대표자명, 정산 계좌 정보(은행명, 계좌번호, 예금주), 세금계산서 발행 정보</td>
            <td style={tdStyle}>계약 종료일로부터 5년</td>
          </tr>
          <tr>
            <td style={tdStyle}>고객 상담</td>
            <td style={tdStyle}>상담 문의 대응 및 처리 결과 회신</td>
            <td style={tdStyle}>이름, 연락처(전화번호 또는 이메일), 문의 내용</td>
            <td style={tdStyle}>상담 완료 후 3년</td>
          </tr>
        </tbody>
      </table>

      <p style={{...pStyle, fontWeight: '600'}}>② 정보주체의 동의를 받아 처리하는 개인정보 항목</p>
      <p style={pStyle}>와우오더는 다음의 개인정보 항목을 「개인정보 보호법」 제15조 제1항 제1호에 따라 정보주체의 동의를 받아 처리하고 있습니다.</p>
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={thStyle}>구분</th>
            <th style={thStyle}>수집 목적</th>
            <th style={thStyle}>수집 항목</th>
            <th style={thStyle}>보유 및 이용 기간</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={tdStyle}>마케팅 정보 수신 (선택 동의)</td>
            <td style={tdStyle}>이벤트·혜택 안내, 광고성 정보 전송, 신규 서비스 홍보</td>
            <td style={tdStyle}>휴대전화번호, 이메일</td>
            <td style={tdStyle}>동의 철회시까지</td>
          </tr>
          <tr>
            <td style={tdStyle}>홈페이지 문의하기</td>
            <td style={tdStyle}>상담 문의 대응</td>
            <td style={tdStyle}>휴대전화번호</td>
            <td style={tdStyle}>상담 문의 대응 완료일로부터 1년</td>
          </tr>
        </tbody>
      </table>

      <p style={{...pStyle, fontWeight: '600'}}>③ 서비스 이용 과정에서 자동으로 수집되는 정보</p>
      <p style={pStyle}>서비스 이용 과정에서 다음의 정보가 자동으로 생성되어 수집될 수 있습니다.</p>
      <p style={pStyle}>IP 주소, 쿠키, 서비스 이용 기록, 방문 일시, 기기 정보(기기 식별자, OS 종류 및 버전, 브라우저 종류 및 버전, 화면 해상도), 불량 이용 기록</p>

      <p style={sectionTitleStyle}>2. 개인정보의 처리 및 보유 기간</p>
      <p style={pStyle}>와우오더는 법령에 따른 개인정보 보유·이용 기간 또는 정보주체로부터 동의받은 보유·이용 기간 내에서 개인정보를 처리·보유합니다. 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.</p>
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={thStyle}>구분</th>
            <th style={thStyle}>보유 기간</th>
            <th style={thStyle}>관련 법령</th>
          </tr>
        </thead>
        <tbody>
          <tr><td style={tdStyle}>매장 회원 정보</td><td style={tdStyle}>회원 탈퇴 시까지</td><td style={tdStyle}>정보주체 동의</td></tr>
          <tr><td style={tdStyle}>계약 또는 청약철회 등에 관한 기록</td><td style={tdStyle}>5년</td><td style={tdStyle}>전자상거래 등에서의 소비자보호에 관한 법률</td></tr>
          <tr><td style={tdStyle}>대금결제 및 재화 등의 공급에 관한 기록</td><td style={tdStyle}>5년</td><td style={tdStyle}>전자상거래 등에서의 소비자보호에 관한 법률</td></tr>
          <tr><td style={tdStyle}>소비자의 불만 또는 분쟁처리에 관한 기록</td><td style={tdStyle}>3년</td><td style={tdStyle}>전자상거래 등에서의 소비자보호에 관한 법률</td></tr>
          <tr><td style={tdStyle}>서비스 방문 기록(접속 로그)</td><td style={tdStyle}>3개월 이상</td><td style={tdStyle}>통신비밀보호법</td></tr>
          <tr><td style={tdStyle}>세금계산서 등 세무 관련 기록</td><td style={tdStyle}>5년</td><td style={tdStyle}>국세기본법</td></tr>
          <tr><td style={tdStyle}>마케팅 수신 동의 정보</td><td style={tdStyle}>동의 철회 시까지</td><td style={tdStyle}>정보주체 동의</td></tr>
        </tbody>
      </table>
      <p style={pStyle}>회원 탈퇴 또는 동의 철회 시, 보유 기간이 경과하거나 처리 목적이 달성된 경우에는 지체 없이 해당 개인정보를 파기합니다. 다만, 관련 법령에 따라 보존할 필요가 있는 경우에는 별도의 데이터베이스(DB)로 이전하여 보관합니다.</p>

      <p style={sectionTitleStyle}>3. 개인정보의 제3자 제공에 관한 사항</p>
      <p style={pStyle}>와우오더는 정보주체의 개인정보를 수집·이용 목적 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 「개인정보 보호법」 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.</p>
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={thStyle}>제공받는 자</th>
            <th style={thStyle}>제공 목적</th>
            <th style={thStyle}>제공 항목</th>
            <th style={thStyle}>보유·이용 기간</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={tdStyle}>나이스페이먼츠(주)</td>
            <td style={tdStyle}>CMS프로그램 제공, CMS출금이체 서비스 제공 및 출금동의 확인, 출금이체 신규등록 및 해지 사실 통지</td>
            <td style={tdStyle}>이름, 예금주 생년월일, 전화번호, 휴대전화번호, 금융기관명, 계좌번호</td>
            <td style={tdStyle}>CMS 출금이체 서비스 제공 종료 시까지</td>
          </tr>
        </tbody>
      </table>
      <p style={pStyle}>상기 나이스페이먼츠(주)에 대한 개인정보 제공은 CMS 자동이체 서비스 이용을 위한 계약의 체결 및 이행에 필수적인 사항으로, 「개인정보 보호법」 제17조 제1항 제2호(계약의 체결·이행)에 따라 정보주체의 동의 없이 제공합니다.</p>
      <p style={pStyle}>다음의 경우에는 정보주체의 동의 없이 개인정보를 제3자에게 제공할 수 있습니다.</p>
      <p style={pStyle}>- 법률에 특별한 규정이 있거나 법령상 의무를 준수하기 위하여 불가피한 경우<br/>- 정보주체 또는 제3자의 급박한 생명, 신체, 재산의 이익을 위하여 필요한 경우<br/>- 통계 작성 및 학술연구 등을 위하여 특정 개인을 알아볼 수 없는 형태로 제공하는 경우</p>

      <p style={sectionTitleStyle}>4. 개인정보 처리의 위탁에 관한 사항</p>
      <p style={pStyle}>와우오더는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.</p>
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={thStyle}>수탁업체(수탁자)</th>
            <th style={thStyle}>위탁업무 내용</th>
            <th style={thStyle}>보유 및 이용 기간</th>
          </tr>
        </thead>
        <tbody>
          <tr><td style={tdStyle}>Amazon Web Services Inc.</td><td style={tdStyle}>데이터 보관 및 시스템 운영</td><td style={tdStyle}>위탁계약 종료 시까지</td></tr>
          <tr><td style={tdStyle}>(주)모두싸인</td><td style={tdStyle}>계약서 관리</td><td style={tdStyle}>위탁계약 종료 시까지</td></tr>
          <tr><td style={tdStyle}>슈어엠</td><td style={tdStyle}>카카오, LMS 메시지 발송</td><td style={tdStyle}>위탁계약 종료 시까지</td></tr>
        </tbody>
      </table>
      <p style={pStyle}>와우오더는 위탁계약 체결 시 「개인정보 보호법」 제26조에 따라 위탁업무 수행 목적 외 개인정보 처리 금지, 기술적·관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리·감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.</p>
      <p style={pStyle}>위탁업무의 내용이나 수탁자가 변경될 경우에는 지체 없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.</p>

      <p style={sectionTitleStyle}>5. 개인정보의 파기 절차 및 방법</p>
      <p style={pStyle}>와우오더는 개인정보 보유 기간의 경과, 처리 목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체 없이 해당 개인정보를 파기합니다.</p>
      <p style={pStyle}>정보주체로부터 동의받은 보유 기간이 경과하거나 처리 목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로 옮기거나 보관장소를 달리하여 보존합니다.</p>
      <p style={pStyle}>가. 파기 절차<br/>파기 사유가 발생한 개인정보를 선정하고, 개인정보 보호책임자의 승인을 받아 파기합니다. 보유 기간 경과 시 정당한 사유가 없는 한 종료일로부터 5일 이내에, 처리 목적 달성 시 불필요한 것으로 인정되는 날로부터 5일 이내에 파기합니다.</p>
      <p style={pStyle}>나. 파기 방법<br/>- 전자적 파일 형태: 기록을 재생할 수 없는 기술적 방법을 사용하여 완전히 삭제<br/>- 종이 문서: 분쇄기로 분쇄하거나 소각하여 파기</p>

      <p style={sectionTitleStyle}>6. 정보주체와 법정대리인의 권리·의무 및 행사방법</p>
      <p style={pStyle}>정보주체는 와우오더에 대해 언제든지 다음의 개인정보 보호 관련 권리를 행사할 수 있습니다.</p>
      <p style={pStyle}>가. 개인정보 열람 요구<br/>나. 오류 등이 있을 경우 정정 요구<br/>다. 삭제 요구<br/>라. 처리정지 요구<br/>마. 개인정보 전송 요구 (「개인정보 보호법」 제35조의2에 해당하는 경우)</p>
      <p style={pStyle}>권리 행사는 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며, 와우오더는 이에 대해 지체 없이 조치하겠습니다. 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수도 있으며, 이 경우 「개인정보 처리 방법에 관한 고시」 별지 제11호 서식에 따른 위임장을 제출하여야 합니다.</p>
      <p style={pStyle}>개인정보의 정정 및 삭제 요구 시 다른 법령에서 해당 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.</p>
      <p style={pStyle}>와우오더는 열람, 정정·삭제, 처리정지 요구 시 요구를 한 자가 본인이거나 정당한 대리인인지를 확인합니다.</p>

      <p style={sectionTitleStyle}>7. 개인정보의 안전성 확보 조치</p>
      <p style={pStyle}>와우오더는 「개인정보 보호법」 제29조에 따라 다음과 같이 안전성 확보에 필요한 기술적·관리적 및 물리적 조치를 하고 있습니다.</p>
      <p style={pStyle}>가. 관리적 조치<br/>- 내부관리계획의 수립 및 시행<br/>- 개인정보 취급 직원의 최소화 및 정기적 교육 실시</p>
      <p style={pStyle}>나. 기술적 조치<br/>- 개인정보처리시스템에 대한 접근권한의 부여·변경·말소를 통한 접근 통제<br/>- 침입차단시스템 및 침입탐지시스템 설치·운영<br/>- 비밀번호, 계좌정보 등 중요 개인정보 암호화 저장 및 SSL/TLS 암호화 통신 적용<br/>- 보안프로그램 설치 및 주기적 갱신·점검<br/>- 접속기록 최소 1년 이상 보관·관리 및 위변조 방지</p>
      <p style={pStyle}>다. 물리적 조치<br/>- 전산실, 자료보관실 등에 대한 출입통제 절차 수립·운영</p>
      <p style={pStyle}>회사가 관련 법령이 정한 개인정보 보호 의무를 다하였음에도 불구하고, 이용자 본인의 부주의나 회사가 관리하지 않는 영역에서의 사고 등 회사의 귀책에 기인하지 않은 손해에 대해서는 회사는 책임을 지지 않습니다. 회사의 개인정보 보호와 관련한 책임은 관련 법령에서 정하는 범위 내에서 부담합니다.</p>

      <p style={sectionTitleStyle}>8. 개인정보를 자동으로 수집하는 장치의 설치·운영 및 거부에 관한 사항</p>
      <p style={pStyle}>와우오더는 이용자에게 개별적인 맞춤 서비스를 제공하기 위해 이용 정보를 저장하고 수시로 불러오는 '쿠키(Cookie)'를 사용합니다.</p>
      <p style={pStyle}>가. 쿠키의 사용 목적<br/>이용자의 접속 빈도나 방문 시간 등을 분석, 이용 형태 및 관심분야 파악, 서비스 이용 환경 최적화 등을 위해 사용됩니다.</p>
      <p style={pStyle}>나. 쿠키의 설치·운영 및 거부<br/>이용자는 쿠키 설치에 대한 선택권을 가지고 있으며, 웹 브라우저 설정을 통해 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수 있습니다.</p>
      <p style={pStyle}>다. 쿠키 설정 방법<br/>Chrome: 설정 {'>'} 개인정보 보호 및 보안 {'>'} 서드 파티 쿠키 {'>'} 서드 파티 쿠키 차단<br/>Safari: 환경설정 {'>'} 개인정보 보호 {'>'} 쿠키 및 웹 사이트 데이터 차단<br/>Samsung Internet: 설정 {'>'} 개인정보 보호 및 보안 {'>'} 쿠키 허용 설정</p>
      <p style={pStyle}>다만, 쿠키 저장을 거부할 경우 일부 맞춤형 서비스 이용에 어려움이 발생할 수 있습니다.</p>

      <p style={sectionTitleStyle}>9. 행태정보의 수집·이용·제공 및 거부에 관한 사항</p>
      <p style={pStyle}>와우오더는 서비스 이용 과정에서 정보주체에게 최적화된 맞춤형 서비스 제공을 위하여 행태정보를 수집·이용할 수 있습니다.</p>
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={thStyle}>수집하는 행태정보 항목</th>
            <th style={thStyle}>수집 방법</th>
            <th style={thStyle}>수집 목적</th>
            <th style={thStyle}>보유·이용 기간</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={tdStyle}>서비스 방문 이력, 메뉴 조회 이력, 주문 패턴</td>
            <td style={tdStyle}>이용자의 서비스 이용 시 자동 수집</td>
            <td style={tdStyle}>매장 이용 패턴 분석 및 서비스 개선</td>
            <td style={tdStyle}>수집일로부터 1년</td>
          </tr>
        </tbody>
      </table>
      <p style={pStyle}>와우오더는 온라인 맞춤형 광고 등에 필요한 최소한의 행태정보만을 수집하며, 민감한 정보를 추론하여 이용하지 않습니다. 만 14세 미만의 이용자를 대상으로 개인 맞춤형 광고를 실시하지 않습니다.</p>

      <p style={sectionTitleStyle}>10. 추가적인 이용·제공 판단 기준</p>
      <p style={pStyle}>와우오더는 「개인정보 보호법」 제15조 제3항 및 제17조 제4항에 따라 다음 사항을 고려하여 정보주체의 동의 없이 개인정보를 추가적으로 이용·제공할 수 있습니다.</p>
      <p style={pStyle}>- 개인정보를 추가적으로 이용·제공하려는 목적이 당초 수집 목적과 관련성이 있는지 여부<br/>- 개인정보를 수집한 정황 또는 처리 관행에 비추어 추가적인 이용·제공에 대한 예측 가능성이 있는지 여부<br/>- 개인정보의 추가적인 이용·제공이 정보주체의 이익을 부당하게 침해하는지 여부<br/>- 가명처리 또는 암호화 등 안전성 확보에 필요한 조치를 하였는지 여부</p>

      <p style={sectionTitleStyle}>11. 가명정보의 처리에 관한 사항</p>
      <p style={pStyle}>와우오더는 통계작성, 과학적 연구, 공익적 기록보존 등을 위하여 수집한 개인정보를 특정 개인을 알아볼 수 없도록 가명처리하여 이용·제공할 수 있습니다.</p>
      <p style={pStyle}>- 가명정보는 재식별되지 않도록 추가 정보와 분리하여 별도 저장·관리합니다.<br/>- 가명정보 처리 시 원래의 개인정보를 복원하기 위한 추가 정보는 별도로 분리하여 보관·관리하는 등 안전조치를 합니다.<br/>- 가명정보 처리에 관한 세부 사항은 추후 가명정보 처리 시 본 처리방침에 안내할 예정입니다.</p>

      <p style={sectionTitleStyle}>12. 개인정보 보호책임자에 관한 사항</p>
      <p style={pStyle}>와우오더는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만 처리 및 피해 구제 등을 위하여 아래와 같이 개인정보보호 책임자를 지정하고 있습니다.</p>
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={thStyle}>구분</th>
            <th style={thStyle}>개인정보 보호책임자 / 개인정보 보호담당자</th>
          </tr>
        </thead>
        <tbody>
          <tr><td style={tdStyle}>성명</td><td style={tdStyle}>박지훈</td></tr>
          <tr><td style={tdStyle}>직위(직책)</td><td style={tdStyle}>CEO</td></tr>
          <tr><td style={tdStyle}>연락처</td><td style={tdStyle}>010-8908-6827</td></tr>
          <tr><td style={tdStyle}>이메일</td><td style={tdStyle}>official@woworder.kr</td></tr>
        </tbody>
      </table>
      <p style={pStyle}>정보주체께서는 와우오더의 서비스를 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만 처리, 피해 구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의하실 수 있습니다. 와우오더는 정보주체의 문의에 대해 지체 없이 답변 및 처리해 드리겠습니다.</p>

      <p style={sectionTitleStyle}>13. 정보주체의 권익침해에 대한 구제방법</p>
      <p style={pStyle}>정보주체는 개인정보침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회, 한국인터넷진흥원 개인정보침해신고센터 등에 분쟁 해결이나 상담 등을 신청할 수 있습니다.</p>
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={thStyle}>기관명</th>
            <th style={thStyle}>연락처</th>
            <th style={thStyle}>홈페이지</th>
          </tr>
        </thead>
        <tbody>
          <tr><td style={tdStyle}>개인정보분쟁조정위원회</td><td style={tdStyle}>(국번없이) 1833-6972</td><td style={tdStyle}>www.kopico.go.kr</td></tr>
          <tr><td style={tdStyle}>개인정보침해신고센터</td><td style={tdStyle}>(국번없이) 118</td><td style={tdStyle}>privacy.kisa.or.kr</td></tr>
          <tr><td style={tdStyle}>대검찰청 사이버수사과</td><td style={tdStyle}>(국번없이) 1301</td><td style={tdStyle}>www.spo.go.kr</td></tr>
          <tr><td style={tdStyle}>경찰청 사이버수사국</td><td style={tdStyle}>(국번없이) 182</td><td style={tdStyle}>ecrm.cyber.go.kr</td></tr>
        </tbody>
      </table>

      <p style={sectionTitleStyle}>14. 개인정보 처리방침 변경</p>
      <p style={pStyle}>이 개인정보 처리방침은 2026. 03. 06 부터 적용됩니다.</p>
    </div>
  );

  // 유효성 검사 함수들
  const validateUsername = (value) => {
    if (!value) return '아이디를 입력해주세요.';
    if (value.includes(' ')) return '아이디에 공백을 포함할 수 없습니다.';
    if (/^\d/.test(value)) return '아이디는 영문자로 시작해야 합니다.';
    if (!/^[a-zA-Z0-9_]+$/.test(value)) return '아이디는 영문, 숫자, 언더스코어(_)만 사용 가능합니다.';
    if (value.length < 4) return '아이디는 4자 이상이어야 합니다.';
    if (value.length > 20) return '아이디는 20자 이하여야 합니다.';
    return '';
  };

  const validatePassword = (value) => {
    if (!value) return '비밀번호를 입력해주세요.';
    if (value.length < 8) return '비밀번호는 8자 이상이어야 합니다.';
    if (value.length > 20) return '비밀번호는 20자 이하여야 합니다.';
    return '';
  };

  const validateConfirmPassword = (value, password) => {
    if (!value) return '비밀번호 확인을 입력해주세요.';
    if (value !== password) return '비밀번호가 일치하지 않습니다.';
    return '';
  };

  const validateEmail = (value) => {
    if (!value) return '이메일을 입력해주세요.';
    if (/[ㄱ-ㅎㅏ-ㅣ가-힣]/.test(value)) return '이메일에 한글을 사용할 수 없습니다.';
    if (!value.includes('@')) return '이메일에 @를 포함해야 합니다.';
    const [localPart, domain] = value.split('@');
    if (!domain) return '@ 뒤에 도메인을 입력해주세요.';
    if (!domain.includes('.')) return '올바른 도메인 형식이 아닙니다. (예: .com, .co.kr)';
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) return '올바른 이메일 형식이 아닙니다.';
    return '';
  };

  const validatePhone = (value) => {
    const rawPhone = value.replace(/[^\d]/g, '');
    if (!value) return '전화번호를 입력해주세요.';
    if (value.replace(/-/g, '') !== rawPhone) return '전화번호는 숫자만 입력 가능합니다.';
    if (rawPhone.length < 10) return '전화번호는 10자리 이상이어야 합니다.';
    if (rawPhone.length > 11) return '전화번호는 11자리 이하여야 합니다.';
    if (!/^01[0-9]/.test(rawPhone)) return '올바른 휴대폰 번호 형식이 아닙니다.';
    return '';
  };

  // 필드 에러 설정 헬퍼 함수
  const setFieldError = (field, error) => {
    setFieldErrors(prev => ({ ...prev, [field]: error }));
  };

  // 필드 에러 초기화 헬퍼 함수
  const clearFieldError = (field) => {
    setFieldErrors(prev => ({ ...prev, [field]: '' }));
  };

  // 사업자번호 포맷팅 (000-00-00000 형식)
  const handleBusinessNumberChange = (e) => {
    const value = e.target.value;
    const numbers = value.replace(/[^\d]/g, '');

    if (numbers.length <= 10) {
      // 하이픈 포맷팅 적용
      let formatted = '';
      if (numbers.length <= 3) {
        formatted = numbers;
      } else if (numbers.length <= 5) {
        formatted = `${numbers.slice(0, 3)}-${numbers.slice(3)}`;
      } else {
        formatted = `${numbers.slice(0, 3)}-${numbers.slice(3, 5)}-${numbers.slice(5)}`;
      }
      setBusinessNumber(formatted);
      setVerificationError('');
    }
  };

  // 하이픈 제거한 순수 숫자만 반환
  const getRawBusinessNumber = () => {
    return businessNumber.replace(/[^\d]/g, '');
  };

  // 사업자번호 확인
  const handleBusinessVerification = async (e) => {
    e.preventDefault();

    const rawNumber = getRawBusinessNumber();

    // 10자리 미만 입력 시
    if (!rawNumber || rawNumber.length !== 10) {
      setVerificationError('사업자번호 10자리를 입력해주세요.');
      return;
    }

    setIsLoading(true);
    setVerificationError('');

    // 타임아웃 설정 (10초)
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000);

    try {
      const response = await fetch(`${API_BASE_URL}/api/verify-business`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ businessNumber: rawNumber }),
        signal: controller.signal
      });

      clearTimeout(timeoutId);
      const data = await response.json();

      if (data.valid) {
        if (data.isRegistered) {
          setVerificationError('해당 사업자번호로 이미 회원가입이 완료되었습니다.');
        } else {
          setIsBusinessVerified(true);
          setStep(2);
        }
      } else {
        setVerificationError('등록되지 않은 사업자번호입니다. 계약 담당자에게 문의해주세요.');
      }
    } catch (error) {
      clearTimeout(timeoutId);
      console.error('사업자번호 확인 오류:', error);

      // 타임아웃 에러 처리
      if (error.name === 'AbortError') {
        setVerificationError('서버 응답이 지연되고 있습니다. 잠시 후 다시 시도해주세요.');
        return;
      }

      // 백엔드가 없을 때 임시 처리
      const validBusinessNumbers = [
        '1234567890',
        '3333333333',
        '1112233333',
        '5556677777'
      ];

      if (validBusinessNumbers.includes(rawNumber)) {
        setIsBusinessVerified(true);
        setStep(2);
      } else {
        setVerificationError('등록되지 않은 사업자번호입니다. 계약 담당자에게 문의해주세요.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // 전화번호 필드인 경우 포맷팅
    if (name === 'phone') {
      const numbers = value.replace(/[^\d]/g, '');
      let formatted = '';

      if (numbers.length <= 3) {
        formatted = numbers;
      } else if (numbers.length <= 7) {
        formatted = `${numbers.slice(0, 3)}-${numbers.slice(3)}`;
      } else if (numbers.length <= 11) {
        formatted = `${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(7, 11)}`;
      } else {
        return; // 11자리 초과 입력 방지
      }

      setFormData(prev => ({
        ...prev,
        phone: formatted
      }));
      return;
    }

    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // 약관 전체동의 핸들러
  const handleAgreeAll = () => {
    const newValue = !agreeAll;
    setAgreeAll(newValue);
    setAgreeTerms(newValue);
    setAgreePrivacy(newValue);
    if (newValue) {
      setTermsError('');
    }
  };

  // 개별 약관 동의 핸들러
  const handleAgreeTerms = () => {
    const newValue = !agreeTerms;
    setAgreeTerms(newValue);
    if (!newValue) {
      setAgreeAll(false);
    } else {
      setTermsError('');
      if (agreePrivacy) {
        setAgreeAll(true);
      }
    }
  };

  const handleAgreePrivacy = () => {
    const newValue = !agreePrivacy;
    setAgreePrivacy(newValue);
    if (!newValue) {
      setAgreeAll(false);
    } else {
      setTermsError('');
      if (agreeTerms) {
        setAgreeAll(true);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSignupError('');

    // 모든 필드 유효성 검사
    const usernameError = validateUsername(formData.username);
    const passwordError = validatePassword(formData.password);
    const confirmPasswordError = validateConfirmPassword(formData.confirmPassword, formData.password);
    const emailError = validateEmail(formData.email);
    const phoneError = validatePhone(formData.phone);

    // 에러가 있으면 각 필드에 에러 메시지 설정
    const newErrors = {
      username: usernameError,
      password: passwordError,
      confirmPassword: confirmPasswordError,
      email: emailError,
      phone: phoneError
    };

    setFieldErrors(newErrors);

    // 에러가 하나라도 있으면 제출 중단
    if (usernameError || passwordError || confirmPasswordError || emailError || phoneError) {
      return;
    }

    // 약관 동의 확인
    if (!agreeTerms) {
      setTermsError('이용약관에 동의해주세요.');
      return;
    }
    if (!agreePrivacy) {
      setTermsError('개인정보 수집 및 이용에 동의해주세요.');
      return;
    }

    const rawNumber = getRawBusinessNumber();

    try {
      // 실제 API 호출
      const response = await fetch(`${API_BASE_URL}/api/signup`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          businessNumber: rawNumber,
          username: formData.username,
          password: formData.password,
          email: formData.email,
          phone: formData.phone
        })
      });

      const data = await response.json();

      if (data.success) {
        // 토큰과 사용자 정보 저장
        localStorage.setItem('token', data.token);
        localStorage.setItem('currentUser', JSON.stringify(data.user));

        alert('회원가입이 완료되었습니다.');
        navigate('/admin');
      } else {
        // 서버 에러 메시지에 따라 해당 필드에 에러 표시
        const errorMessage = data.message || '회원가입에 실패했습니다.';

        if (errorMessage.includes('이메일')) {
          setFieldError('email', errorMessage);
        } else if (errorMessage.includes('아이디')) {
          setFieldError('username', errorMessage);
        } else if (errorMessage.includes('전화번호')) {
          setFieldError('phone', errorMessage);
        } else {
          setSignupError(errorMessage);
        }
      }
    } catch (error) {
      console.error('회원가입 오류:', error);

      // 백엔드가 없을 때 임시 처리
      const users = JSON.parse(localStorage.getItem('users') || '[]');
      users.push({
        businessNumber: rawNumber,
        username: formData.username,
        password: formData.password,
        email: formData.email,
        phone: formData.phone
      });
      localStorage.setItem('users', JSON.stringify(users));

      alert('회원가입이 완료되었습니다!');
      navigate('/login');
    }
  };

  // 화면 크기에 따른 스케일 조정
  useEffect(() => {
    const scaleUI = () => {
      const wrapper = document.querySelector('.signup-wrapper');
      if (wrapper) {
        const viewportWidth = window.innerWidth;
        const scale = Math.min(viewportWidth / 400, 1.5);
        wrapper.style.zoom = scale;
      }
    };
    scaleUI();
  }, []);

  return (
    <>
      <style jsx="true">{`
        .signup-page {
          min-height: 100vh;
          background-color: #FFFFFF;
          display: flex;
          justify-content: center;
          align-items: flex-start;
          padding-top: 60px;
          -webkit-text-size-adjust: 100%;
          text-size-adjust: 100%;
        }

        .signup-wrapper {
          width: 400px;
          transform-origin: top center;
        }

        @media screen and (min-width: 401px) {
          .signup-wrapper {
            zoom: calc(100vw / 400);
          }
        }

        @media screen and (min-width: 600px) {
          .signup-wrapper {
            zoom: 1.5;
          }
        }

        @media screen and (max-width: 400px) {
          .signup-wrapper {
            width: 400px;
            zoom: calc(100vw / 400);
          }
        }

        .signup-input::placeholder {
          color: #9D9D9D;
          font-size: 15px;
          font-weight: 400;
        }
        .signup-input.floating::placeholder {
          color: transparent;
        }
        .signup-input:focus {
          outline: none;
        }
        .floating-label {
          position: absolute;
          left: 17px;
          top: 50%;
          transform: translateY(-50%);
          font-size: 15px;
          font-weight: 500;
          color: #9D9D9D;
          pointer-events: none;
          transition: all 0.2s ease;
          transform-origin: left center;
          z-index: 2;
        }
        .floating-label.active {
          top: 12px;
          transform: translateY(0);
          font-size: 12px;
        }
        .signup-page button:focus {
          outline: none;
        }
        .signup-page label,
        .signup-page div[style] {
          -webkit-tap-highlight-color: transparent;
          outline: none;
        }
        .signup-input:-webkit-autofill,
        .signup-input:-webkit-autofill:hover,
        .signup-input:-webkit-autofill:focus,
        .signup-input:-webkit-autofill:active {
          -webkit-box-shadow: 0 0 0 30px white inset !important;
          box-shadow: 0 0 0 30px white inset !important;
          -webkit-text-fill-color: #000000 !important;
        }
      `}</style>
      <div className="signup-page">
        <div className="signup-wrapper">
          <div style={styles.card}>
          {step === 1 ? (
            // Step 1: 사업자번호 확인
            <>
              <h1 style={{...styles.title, fontSize: '28px'}}>사업자 번호 확인</h1>
              <p style={{...styles.subtitle, fontSize: '18px'}}>
                회원가입을 위해 먼저 등록된 사업자 번호를 확인해주세요.
              </p>

              <form onSubmit={handleBusinessVerification} style={styles.form}>
                <div style={styles.inputGroup}>
                  <div style={{ position: 'relative' }}>
                    <input
                      type="text"
                      inputMode="numeric"
                      className="signup-input floating"
                      value={businessNumber}
                      onChange={handleBusinessNumberChange}
                      onFocus={() => {
                        setFocusedField('businessNumber');
                        setVerificationError('');
                      }}
                      onBlur={() => setFocusedField(null)}
                      style={{
                        ...styles.input,
                        height: '60px',
                        paddingTop: focusedField === 'businessNumber' || businessNumber ? '18px' : '12px',
                        paddingBottom: focusedField === 'businessNumber' || businessNumber ? '2px' : '12px',
                        borderColor: verificationError
                          ? '#F41717'
                          : focusedField === 'businessNumber'
                            ? '#FDCD27'
                            : '#D9D9D9',
                        borderWidth: focusedField === 'businessNumber' ? '1.5px' : '1px',
                        backgroundColor: verificationError ? '#FFF5F5' : '#FFFFFF',
                        caretColor: '#FDCD27'
                      }}
                      placeholder="사업자번호"
                    />
                    <span className={`floating-label${focusedField === 'businessNumber' || businessNumber ? ' active' : ''}`}>
                      사업자번호
                    </span>
                  </div>
                  {verificationError ? (
                    <span style={styles.errorHelper}>
                      {verificationError}
                    </span>
                  ) : (
                    <span style={styles.helper}>
                      하이픈(-)없이 숫자만 입력해주세요.
                    </span>
                  )}
                </div>

                <div style={styles.buttonWrapper}>
                  <button
                    type="submit"
                    style={{
                      ...styles.submitButton,
                      opacity: isLoading ? 0.7 : 1,
                      cursor: isLoading ? 'not-allowed' : 'pointer'
                    }}
                    disabled={isLoading}
                  >
                    {isLoading ? '확인 중...' : '사업자번호 확인'}
                  </button>
                </div>
              </form>

              <div style={styles.linkGroup}>
                <span style={styles.linkText}>이미 계정이 있으신가요? </span>
                <Link to="/login" style={styles.link}>
                  로그인
                </Link>
              </div>
            </>
          ) : (
          // Step 2: 회원정보 입력
          <>
            <div style={styles.titleWrapper}>
              <h1 style={styles.title}>관리자 회원가입</h1>
              <img src={logo} alt="로고" style={styles.logo} />
            </div>

            <form onSubmit={handleSubmit} style={{...styles.form, gap: '24px'}} noValidate>
              <div style={styles.inputGroup}>
                <label style={styles.label}>아이디 <span style={styles.requiredMark}>*</span></label>
                <input
                  type="text"
                  name="username"
                  className="signup-input"
                  value={formData.username}
                  onChange={(e) => {
                    handleChange(e);
                    if (fieldErrors.username) clearFieldError('username');
                  }}
                  onFocus={() => {
                    setFocusedField('username');
                    clearFieldError('username');
                  }}
                  onBlur={() => {
                    setFocusedField(null);
                    const error = validateUsername(formData.username);
                    if (error) setFieldError('username', error);
                  }}
                  style={{
                    ...styles.input,
                    borderColor: fieldErrors.username
                      ? '#F41717'
                      : focusedField === 'username'
                        ? '#FDCD27'
                        : '#D9D9D9',
                    borderWidth: focusedField === 'username' ? '1.5px' : '1px',
                    backgroundColor: fieldErrors.username ? '#FFF5F5' : '#FFFFFF'
                  }}
                  placeholder="아이디를 입력해주세요"
                />
                {fieldErrors.username && (
                  <span style={styles.fieldError}>{fieldErrors.username}</span>
                )}
              </div>

              <div style={styles.inputGroup}>
                <label style={styles.label}>비밀번호 <span style={styles.requiredMark}>*</span></label>
                <div style={styles.passwordWrapper}>
                  <input
                    type={showPassword ? 'text' : 'password'}
                    name="password"
                    className="signup-input"
                    value={formData.password}
                    onChange={(e) => {
                      handleChange(e);
                      if (fieldErrors.password) clearFieldError('password');
                    }}
                    onFocus={() => {
                      setFocusedField('password');
                      clearFieldError('password');
                    }}
                    onBlur={() => {
                      setFocusedField(null);
                      const error = validatePassword(formData.password);
                      if (error) setFieldError('password', error);
                    }}
                    style={{
                      ...styles.input,
                      borderColor: fieldErrors.password
                        ? '#F41717'
                        : focusedField === 'password'
                          ? '#FDCD27'
                          : '#D9D9D9',
                      borderWidth: focusedField === 'password' ? '1.5px' : '1px',
                      backgroundColor: fieldErrors.password ? '#FFF5F5' : '#FFFFFF',
                      paddingRight: '48px'
                    }}
                    placeholder="비밀번호를 입력해주세요"
                  />
                  <button
                    type="button"
                    tabIndex={-1}
                    onClick={() => setShowPassword(!showPassword)}
                    style={styles.passwordToggle}
                  >
                    {showPassword ? (
                      <svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.8828 6.18359C10.8828 6.80688 10.6352 7.40464 10.1945 7.84536C9.75376 8.28609 9.156 8.53369 8.53271 8.53369C7.90943 8.53369 7.31167 8.28609 6.87094 7.84536C6.43022 7.40464 6.18262 6.80688 6.18262 6.18359C6.18262 5.56031 6.43022 4.96255 6.87094 4.52182C7.31167 4.08109 7.90943 3.8335 8.53271 3.8335C9.156 3.8335 9.75376 4.08109 10.1945 4.52182C10.6352 4.96255 10.8828 5.56031 10.8828 6.18359Z" stroke="#9D9D9D" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M0.700195 6.18357C1.95358 2.97412 4.88024 0.700012 8.53385 0.700012C12.1875 0.700012 15.1141 2.97412 16.3675 6.18357C15.1141 9.39302 12.1875 11.6671 8.53385 11.6671C4.88024 11.6671 1.95358 9.39302 0.700195 6.18357Z" stroke="#9D9D9D" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    ) : (
                      <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.54016 1.50721C7.87046 1.46897 8.2027 1.44987 8.53521 1.45001C12.1895 1.45001 15.1166 3.7247 16.3702 6.93496C16.0667 7.71582 15.6567 8.45097 15.1519 9.11953M4.24162 2.64025C2.64328 3.61578 1.40535 5.12728 0.700195 6.93496C1.9538 10.1452 4.88096 12.4199 8.53521 12.4199C10.049 12.4279 11.5354 12.0156 12.8288 11.2289M6.87419 5.2738C6.6559 5.4921 6.48275 5.75126 6.36462 6.03648C6.24648 6.32171 6.18568 6.62741 6.18568 6.93613C6.18568 7.24485 6.24648 7.55055 6.36462 7.83578C6.48275 8.121 6.6559 8.38016 6.87419 8.59846C7.09247 8.81676 7.35161 8.98993 7.63681 9.10807C7.92201 9.22621 8.22769 9.28702 8.53638 9.28702C8.84508 9.28702 9.15076 9.22621 9.43596 9.10807C9.72116 8.98993 9.9803 8.81676 10.1986 8.59846" stroke="#9D9D9D" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M2.26855 0.700012L14.8046 12.7" stroke="#9D9D9D" strokeWidth="1.4" strokeLinecap="round"/>
                      </svg>
                    )}
                  </button>
                </div>
                {fieldErrors.password && (
                  <span style={styles.fieldError}>{fieldErrors.password}</span>
                )}
              </div>

              <div style={styles.inputGroup}>
                <label style={styles.label}>비밀번호 확인 <span style={styles.requiredMark}>*</span></label>
                <div style={styles.passwordWrapper}>
                  <input
                    type={showConfirmPassword ? 'text' : 'password'}
                    name="confirmPassword"
                    className="signup-input"
                    value={formData.confirmPassword}
                    onChange={(e) => {
                      handleChange(e);
                      if (fieldErrors.confirmPassword) clearFieldError('confirmPassword');
                    }}
                    onFocus={() => {
                      setFocusedField('confirmPassword');
                      clearFieldError('confirmPassword');
                    }}
                    onBlur={() => {
                      setFocusedField(null);
                      const error = validateConfirmPassword(formData.confirmPassword, formData.password);
                      if (error) setFieldError('confirmPassword', error);
                    }}
                    style={{
                      ...styles.input,
                      borderColor: fieldErrors.confirmPassword
                        ? '#F41717'
                        : focusedField === 'confirmPassword'
                          ? '#FDCD27'
                          : '#D9D9D9',
                      borderWidth: focusedField === 'confirmPassword' ? '1.5px' : '1px',
                      backgroundColor: fieldErrors.confirmPassword ? '#FFF5F5' : '#FFFFFF',
                      paddingRight: '48px'
                    }}
                    placeholder="비밀번호를 다시 입력해주세요"
                  />
                  <button
                    type="button"
                    tabIndex={-1}
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    style={styles.passwordToggle}
                  >
                    {showConfirmPassword ? (
                      <svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.8828 6.18359C10.8828 6.80688 10.6352 7.40464 10.1945 7.84536C9.75376 8.28609 9.156 8.53369 8.53271 8.53369C7.90943 8.53369 7.31167 8.28609 6.87094 7.84536C6.43022 7.40464 6.18262 6.80688 6.18262 6.18359C6.18262 5.56031 6.43022 4.96255 6.87094 4.52182C7.31167 4.08109 7.90943 3.8335 8.53271 3.8335C9.156 3.8335 9.75376 4.08109 10.1945 4.52182C10.6352 4.96255 10.8828 5.56031 10.8828 6.18359Z" stroke="#9D9D9D" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M0.700195 6.18357C1.95358 2.97412 4.88024 0.700012 8.53385 0.700012C12.1875 0.700012 15.1141 2.97412 16.3675 6.18357C15.1141 9.39302 12.1875 11.6671 8.53385 11.6671C4.88024 11.6671 1.95358 9.39302 0.700195 6.18357Z" stroke="#9D9D9D" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    ) : (
                      <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.54016 1.50721C7.87046 1.46897 8.2027 1.44987 8.53521 1.45001C12.1895 1.45001 15.1166 3.7247 16.3702 6.93496C16.0667 7.71582 15.6567 8.45097 15.1519 9.11953M4.24162 2.64025C2.64328 3.61578 1.40535 5.12728 0.700195 6.93496C1.9538 10.1452 4.88096 12.4199 8.53521 12.4199C10.049 12.4279 11.5354 12.0156 12.8288 11.2289M6.87419 5.2738C6.6559 5.4921 6.48275 5.75126 6.36462 6.03648C6.24648 6.32171 6.18568 6.62741 6.18568 6.93613C6.18568 7.24485 6.24648 7.55055 6.36462 7.83578C6.48275 8.121 6.6559 8.38016 6.87419 8.59846C7.09247 8.81676 7.35161 8.98993 7.63681 9.10807C7.92201 9.22621 8.22769 9.28702 8.53638 9.28702C8.84508 9.28702 9.15076 9.22621 9.43596 9.10807C9.72116 8.98993 9.9803 8.81676 10.1986 8.59846" stroke="#9D9D9D" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M2.26855 0.700012L14.8046 12.7" stroke="#9D9D9D" strokeWidth="1.4" strokeLinecap="round"/>
                      </svg>
                    )}
                  </button>
                </div>
                {fieldErrors.confirmPassword && (
                  <span style={styles.fieldError}>{fieldErrors.confirmPassword}</span>
                )}
              </div>

              <div style={styles.inputGroup}>
                <label style={styles.label}>이메일 <span style={styles.requiredMark}>*</span></label>
                <input
                  type="email"
                  name="email"
                  className="signup-input"
                  value={formData.email}
                  onChange={(e) => {
                    handleChange(e);
                    if (fieldErrors.email) clearFieldError('email');
                  }}
                  onFocus={() => {
                    setFocusedField('email');
                    clearFieldError('email');
                  }}
                  onBlur={() => {
                    setFocusedField(null);
                    const error = validateEmail(formData.email);
                    if (error) setFieldError('email', error);
                  }}
                  style={{
                    ...styles.input,
                    borderColor: fieldErrors.email
                      ? '#F41717'
                      : focusedField === 'email'
                        ? '#FDCD27'
                        : '#D9D9D9',
                    borderWidth: focusedField === 'email' ? '1.5px' : '1px',
                    backgroundColor: fieldErrors.email ? '#FFF5F5' : '#FFFFFF'
                  }}
                  placeholder="이메일을 입력해주세요"
                />
                {fieldErrors.email && (
                  <span style={styles.fieldError}>{fieldErrors.email}</span>
                )}
              </div>

              <div style={styles.inputGroup}>
                <label style={styles.label}>전화번호 <span style={styles.requiredMark}>*</span></label>
                <input
                  type="tel"
                  name="phone"
                  className="signup-input"
                  value={formData.phone}
                  onChange={(e) => {
                    handleChange(e);
                    if (fieldErrors.phone) clearFieldError('phone');
                  }}
                  onFocus={() => {
                    setFocusedField('phone');
                    clearFieldError('phone');
                  }}
                  onBlur={() => {
                    setFocusedField(null);
                    const error = validatePhone(formData.phone);
                    if (error) setFieldError('phone', error);
                  }}
                  style={{
                    ...styles.input,
                    borderColor: fieldErrors.phone
                      ? '#F41717'
                      : focusedField === 'phone'
                        ? '#FDCD27'
                        : '#D9D9D9',
                    borderWidth: focusedField === 'phone' ? '1.5px' : '1px',
                    backgroundColor: fieldErrors.phone ? '#FFF5F5' : '#FFFFFF'
                  }}
                  placeholder="전화번호를 입력해주세요"
                />
                {fieldErrors.phone && (
                  <span style={styles.fieldError}>{fieldErrors.phone}</span>
                )}
              </div>

              {/* 약관 동의 섹션 */}
              <div style={styles.termsSection}>
                {/* 전체동의 */}
                <div style={styles.termsRow} onClick={handleAgreeAll}>
                  <div style={styles.checkboxWrapper}>
                    <input
                      type="checkbox"
                      checked={agreeAll}
                      onChange={handleAgreeAll}
                      style={styles.hiddenCheckbox}
                    />
                    <div style={{
                      ...styles.customCheckbox,
                      backgroundColor: agreeAll ? '#FDCD27' : '#FFFFFF',
                      borderColor: agreeAll ? '#FDCD27' : '#D9D9D9'
                    }}>
                      {agreeAll && (
                        <svg width="10" height="8" viewBox="0 0 10 8" fill="none">
                          <path d="M1 4L3.5 7L9 1" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      )}
                    </div>
                  </div>
                  <span style={styles.agreeAllText}>약관 전체동의</span>
                </div>

                {/* 분리선 */}
                <div style={styles.termsDivider}></div>

                {/* 이용약관 동의 */}
                <div style={styles.termsRowWithExpand}>
                  <div style={styles.termsRow} onClick={handleAgreeTerms}>
                    <div style={styles.checkboxWrapper}>
                      <input
                        type="checkbox"
                        checked={agreeTerms}
                        onChange={handleAgreeTerms}
                        style={styles.hiddenCheckbox}
                      />
                      <div style={{
                        ...styles.customCheckbox,
                        backgroundColor: agreeTerms ? '#FDCD27' : '#FFFFFF',
                        borderColor: agreeTerms ? '#FDCD27' : '#D9D9D9'
                      }}>
                        {agreeTerms && (
                          <svg width="10" height="8" viewBox="0 0 10 8" fill="none">
                            <path d="M1 4L3.5 7L9 1" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                        )}
                      </div>
                    </div>
                    <span style={styles.termsText}>이용약관 동의(필수)</span>
                  </div>
                  <button type="button" style={styles.expandButton} onClick={() => setShowTermsModal(true)}>
                    <svg width="9" height="17" viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" clipRule="evenodd" d="M8.6564 7.58158C8.87641 7.82102 9 8.14573 9 8.48431C9 8.82289 8.87641 9.1476 8.6564 9.38704L2.01766 16.6102C1.90941 16.7321 1.77991 16.8294 1.63673 16.8963C1.49356 16.9633 1.33956 16.9985 1.18374 17C1.02792 17.0014 0.873388 16.9691 0.729164 16.9049C0.58494 16.8407 0.45391 16.7459 0.343723 16.626C0.233536 16.5061 0.146396 16.3636 0.0873895 16.2066C0.0283826 16.0497 -0.00130979 15.8816 4.42533e-05 15.7121C0.0013983 15.5425 0.033772 15.375 0.0952763 15.2192C0.156781 15.0634 0.246183 14.9225 0.358269 14.8047L6.16732 8.48431L0.358268 2.16389C0.144498 1.92308 0.0262111 1.60054 0.0288849 1.26576C0.0315587 0.930971 0.154979 0.610722 0.372564 0.373981C0.590148 0.137243 0.884488 0.00295635 1.19219 4.76316e-05C1.49989 -0.00286109 1.79633 0.125837 2.01766 0.358427L8.6564 7.58158Z" fill="#D9D9D9"/>
                    </svg>
                  </button>
                </div>

                {/* 개인정보 동의 */}
                <div style={{...styles.termsRowWithExpand, marginTop: '24px'}}>
                  <div style={styles.termsRow} onClick={handleAgreePrivacy}>
                    <div style={styles.checkboxWrapper}>
                      <input
                        type="checkbox"
                        checked={agreePrivacy}
                        onChange={handleAgreePrivacy}
                        style={styles.hiddenCheckbox}
                      />
                      <div style={{
                        ...styles.customCheckbox,
                        backgroundColor: agreePrivacy ? '#FDCD27' : '#FFFFFF',
                        borderColor: agreePrivacy ? '#FDCD27' : '#D9D9D9'
                      }}>
                        {agreePrivacy && (
                          <svg width="10" height="8" viewBox="0 0 10 8" fill="none">
                            <path d="M1 4L3.5 7L9 1" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                        )}
                      </div>
                    </div>
                    <span style={styles.termsText}>개인정보 수집 및 이용동의(필수)</span>
                  </div>
                  <button type="button" style={styles.expandButton} onClick={() => setShowPrivacyModal(true)}>
                    <svg width="9" height="17" viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" clipRule="evenodd" d="M8.6564 7.58158C8.87641 7.82102 9 8.14573 9 8.48431C9 8.82289 8.87641 9.1476 8.6564 9.38704L2.01766 16.6102C1.90941 16.7321 1.77991 16.8294 1.63673 16.8963C1.49356 16.9633 1.33956 16.9985 1.18374 17C1.02792 17.0014 0.873388 16.9691 0.729164 16.9049C0.58494 16.8407 0.45391 16.7459 0.343723 16.626C0.233536 16.5061 0.146396 16.3636 0.0873895 16.2066C0.0283826 16.0497 -0.00130979 15.8816 4.42533e-05 15.7121C0.0013983 15.5425 0.033772 15.375 0.0952763 15.2192C0.156781 15.0634 0.246183 14.9225 0.358269 14.8047L6.16732 8.48431L0.358268 2.16389C0.144498 1.92308 0.0262111 1.60054 0.0288849 1.26576C0.0315587 0.930971 0.154979 0.610722 0.372564 0.373981C0.590148 0.137243 0.884488 0.00295635 1.19219 4.76316e-05C1.49989 -0.00286109 1.79633 0.125837 2.01766 0.358427L8.6564 7.58158Z" fill="#D9D9D9"/>
                    </svg>
                  </button>
                </div>

                {/* 약관 동의 에러 메시지 */}
                {termsError && (
                  <div style={styles.termsErrorMessage}>{termsError}</div>
                )}
              </div>

              {signupError && (
                <div style={styles.error}>
                  {signupError}
                </div>
              )}

              <div style={styles.buttonGroup}>
                <button
                  type="button"
                  onClick={() => setStep(1)}
                  style={styles.backButton}
                >
                  이전
                </button>
                <button type="submit" style={styles.signupButton}>
                  회원가입
                </button>
              </div>
            </form>
          </>
        )}
        </div>
        </div>
      </div>

      {/* 이용약관 모달 */}
      {showTermsModal && (
        <div style={styles.modalOverlay} onClick={() => setShowTermsModal(false)}>
          <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <div style={styles.modalHeader}>
              <h2 style={styles.modalTitle}>이용약관</h2>
              <button style={styles.modalCloseButton} onClick={() => setShowTermsModal(false)}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M18 6L6 18M6 6L18 18" stroke="#333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
            <div style={styles.modalBody}>
              <div style={styles.modalText}>
                {termsOfServiceContent.split('\n').map((line, i) => {
                  if (i === 0 && line.includes('와우오더 서비스 이용약관')) {
                    return <div key={i} style={{ fontWeight: '700', fontSize: '16px', color: '#111', marginBottom: '12px' }}>{line}</div>;
                  }
                  if (/^제\d+조\s/.test(line)) {
                    return (
                      <div key={i}>
                        {i > 0 && <div style={{ height: '16px' }} />}
                        <div style={{ fontWeight: '700', fontSize: '15px', color: '#111' }}>{line}</div>
                        <div style={{ borderBottom: '1px solid #DDDDDD', margin: '8px 0 10px 0' }} />
                      </div>
                    );
                  }
                  if (line === '') return <div key={i} style={{ height: '10px' }} />;
                  return <div key={i}>{line}</div>;
                })}
              </div>
            </div>
            <div style={styles.modalFooter}>
              <button style={styles.modalConfirmButton} onClick={() => setShowTermsModal(false)}>
                확인
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 개인정보 처리방침 모달 */}
      {showPrivacyModal && (
        <div style={styles.modalOverlay} onClick={() => setShowPrivacyModal(false)}>
          <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <div style={styles.modalHeader}>
              <h2 style={styles.modalTitle}>개인정보 처리방침</h2>
              <button style={styles.modalCloseButton} onClick={() => setShowPrivacyModal(false)}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M18 6L6 18M6 6L18 18" stroke="#333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
            <div style={styles.modalBody}>
              <div style={styles.modalText}>{privacyPolicyContent}</div>
            </div>
            <div style={styles.modalFooter}>
              <button style={styles.modalConfirmButton} onClick={() => setShowPrivacyModal(false)}>
                확인
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const styles = {
  card: {
    backgroundColor: '#FFFFFF',
    padding: '0 30px',
    width: '100%',
    boxSizing: 'border-box'
  },
  titleWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 0
  },
  title: {
    fontSize: '24px',
    fontWeight: 'bold',
    lineHeight: '150%',
    marginTop: 0,
    marginBottom: 0,
    textAlign: 'left',
    color: '#000000'
  },
  logo: {
    width: '91px',
    height: '91px',
    objectFit: 'contain',
    flexShrink: 0,
    marginTop: '-10px'
  },
  subtitle: {
    fontSize: '14px',
    fontWeight: 'bold',
    lineHeight: '150%',
    color: '#4B4B4B',
    textAlign: 'left',
    marginTop: '10px',
    marginBottom: '32px'
  },
  form: {
    display: 'flex',
    flexDirection: 'column'
  },
  inputGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  label: {
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '140%',
    color: '#828A8F'
  },
  requiredMark: {
    color: '#F41717'
  },
  fieldError: {
    fontSize: '12px',
    fontWeight: '400',
    lineHeight: '140%',
    color: '#F41717',
    textAlign: 'left',
    marginTop: '0'
  },
  passwordWrapper: {
    position: 'relative',
    width: '100%'
  },
  passwordToggle: {
    position: 'absolute',
    right: '16px',
    top: '50%',
    transform: 'translateY(-50%)',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  input: {
    width: '100%',
    height: '52px',
    padding: '12px 16px',
    border: '1px solid #D9D9D9',
    borderRadius: '8px',
    backgroundColor: '#FFFFFF',
    fontSize: '15px',
    fontWeight: '500',
    fontFamily: 'inherit',
    outline: 'none',
    boxSizing: 'border-box',
    transition: 'border-color 0.2s'
  },
  helper: {
    fontSize: '13px',
    fontWeight: '400',
    lineHeight: '140%',
    color: '#AEAEAE',
    marginTop: '0'
  },
  errorHelper: {
    fontSize: '13px',
    fontWeight: '400',
    lineHeight: '140%',
    color: '#F41717',
    marginTop: '0'
  },
  buttonWrapper: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '40px'
  },
  error: {
    color: '#F41717',
    fontSize: '14px',
    fontWeight: '600',
    textAlign: 'left',
    marginTop: '8px'
  },
  // 약관 동의 섹션 스타일
  termsSection: {
    marginTop: '20px'
  },
  termsRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    cursor: 'pointer'
  },
  termsRowWithExpand: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  expandButton: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  checkboxWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  hiddenCheckbox: {
    position: 'absolute',
    opacity: 0,
    width: '20px',
    height: '20px',
    cursor: 'pointer'
  },
  customCheckbox: {
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    border: '1px solid #D9D9D9',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.2s'
  },
  agreeAllText: {
    fontSize: '18px',
    fontWeight: '600',
    lineHeight: '16px',
    color: '#000000'
  },
  termsDivider: {
    height: '1px',
    backgroundColor: '#D9D9D9',
    marginTop: '24px',
    marginBottom: '24px'
  },
  termsText: {
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '16px',
    color: '#3F3F3F'
  },
  termsErrorMessage: {
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '140%',
    color: '#F41717',
    textAlign: 'left',
    marginTop: '32px'
  },
  buttonGroup: {
    display: 'flex',
    gap: '12px',
    marginTop: '16px'
  },
  backButton: {
    width: '120px',
    height: '58px',
    backgroundColor: '#F5F5F5',
    color: '#959595',
    border: 'none',
    borderRadius: '8px',
    fontSize: '18px',
    fontWeight: 'bold',
    lineHeight: '18px',
    padding: '15px 24px',
    cursor: 'pointer',
    flexShrink: 0
  },
  signupButton: {
    width: '253px',
    height: '58px',
    backgroundColor: '#FDCD27',
    color: '#FFFFFF',
    border: 'none',
    borderRadius: '8px',
    fontSize: '18px',
    fontWeight: 'bold',
    lineHeight: '18px',
    padding: '15px 24px',
    cursor: 'pointer',
    flexGrow: 1
  },
  submitButton: {
    width: '100%',
    height: '50px',
    backgroundColor: '#FDCD27',
    color: '#FFFFFF',
    border: 'none',
    borderRadius: '8px',
    fontSize: '18px',
    fontWeight: '900',
    lineHeight: '18px',
    cursor: 'pointer'
  },
  linkGroup: {
    textAlign: 'center',
    marginTop: '28px'
  },
  linkText: {
    fontSize: '14px',
    fontWeight: '600',
    lineHeight: '16px',
    color: '#9D9D9D'
  },
  link: {
    fontSize: '14px',
    fontWeight: 'bold',
    lineHeight: '16px',
    color: '#FDCD27',
    textDecoration: 'underline'
  },
  // 모달 스타일
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
    padding: '20px'
  },
  modalContent: {
    backgroundColor: '#FFFFFF',
    borderRadius: '16px',
    width: '100%',
    maxWidth: '500px',
    maxHeight: '80vh',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
  },
  modalHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '20px 24px',
    borderBottom: '1px solid #E8E8E8'
  },
  modalTitle: {
    fontSize: '18px',
    fontWeight: '700',
    color: '#333',
    margin: 0
  },
  modalCloseButton: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  modalBody: {
    flex: 1,
    overflow: 'auto',
    padding: '24px'
  },
  modalText: {
    fontSize: '14px',
    lineHeight: '1.8',
    color: '#333',
    fontFamily: 'inherit',
    margin: 0
  },
  modalFooter: {
    padding: '16px 24px',
    borderTop: '1px solid #E8E8E8'
  },
  modalConfirmButton: {
    width: '100%',
    height: '52px',
    backgroundColor: '#FDCD27',
    color: '#FFFFFF',
    border: 'none',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: '700',
    cursor: 'pointer'
  }
};

export default SignupPage;